import { FDBodyText, FDBox, FDStack } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';

const TaxStrategySettingsTabColumnLabels = ({ resource }) => {
  return (
    <FDStack direction={'row'} spacing={2}>
      <FDBox maxWidth={'352px'} flex={1} />
      <FDBox width={'250px'}>
        <FDBodyText value={resource.attr('currentYearLabel')} />
      </FDBox>
      <FDBox width={'250px'}>
        <FDBodyText value={resource.attr('nextYearLabel')} />
      </FDBox>
      <FDBox width={'250px'}>
        <FDBodyText value={resource.attr('ongoingYearLabel')} />
      </FDBox>
    </FDStack>
  );
};

TaxStrategySettingsTabColumnLabels.defaultProps = {
};

TaxStrategySettingsTabColumnLabels.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default TaxStrategySettingsTabColumnLabels;
